export default __webpack_public_path__ + "static/media/arrow-primary-left.ddbe3505.svg";